import React from 'react';

/**
 * The 0–5 rating scale every interview form in this module uses.
 * Index is the stored value, so the labels double as the option list.
 */
export const RATING_LABELS = ['Poor', 'Fair', 'Average', 'Good', 'Superior', 'Excellent'];

/**
 * One criterion, scored 0–5. Label and options sit on one line when there is
 * room and stack when there is not, so it reads the same in a modal or inline.
 */
const RatingRow = ({ label, name, value, onChange, disabled = false }) => (
  <div
    className="d-flex flex-wrap align-items-center py-2"
    style={{ borderBottom: '1px solid #f0f0f0', gap: 8 }}
  >
    <div
      style={{ flex: '0 0 170px', fontWeight: 600, fontSize: '0.82rem', color: '#495057' }}
    >
      {label}
    </div>

    <div className="d-flex flex-wrap" style={{ gap: 4 }}>
      {RATING_LABELS.map((text, score) => {
        const selected = Number(value) === score;

        return (
          <label
            key={text}
            className="mb-0 d-flex align-items-center px-2"
            style={{
              cursor: disabled ? 'default' : 'pointer',
              fontSize: '0.76rem',
              paddingTop: 3,
              paddingBottom: 3,
              borderRadius: 4,
              border: `1px solid ${selected ? '#009879' : '#dee2e6'}`,
              background: selected ? '#e8f5f1' : '#fff',
              color: selected ? '#00705a' : '#495057',
              fontWeight: selected ? 600 : 400,
            }}
          >
            <input
              type="radio"
              name={name}
              value={score}
              disabled={disabled}
              checked={selected}
              onChange={() => onChange(name, score)}
              className="mr-1"
            />
            {text}
          </label>
        );
      })}
    </div>
  </div>
);

export default RatingRow;
